'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagNfAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H20V20H28V0Z", fill: "#219646" }),
      /* @__PURE__ */ jsx("path", { d: "M8.00016 0H0V20H8.00016V0Z", fill: "#219646" }),
      /* @__PURE__ */ jsx("path", { d: "M20 0H8.00016V20H20V0Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5916 5.33753L13.1543 3.31184C13.2533 2.95552 13.6427 2.66667 14.0002 2.66667C14.3684 2.66667 14.7492 2.9633 14.846 3.31184L15.4087 5.33753C15.384 5.33476 15.3589 5.33333 15.3335 5.33333C14.9653 5.33333 14.6668 5.63181 14.6668 6C14.6668 6.36819 14.9653 6.66667 15.3335 6.66667C15.4863 6.66667 15.6272 6.61523 15.7396 6.52872L16.1532 8.01765C16.1041 8.00611 16.0528 8 16.0002 8C15.632 8 15.3335 8.29848 15.3335 8.66667C15.3335 9.03486 15.632 9.33333 16.0002 9.33333C16.1814 9.33333 16.3458 9.26099 16.466 9.1436L16.9008 10.7089C16.828 10.6816 16.7491 10.6667 16.6668 10.6667C16.2986 10.6667 16.0002 10.9651 16.0002 11.3333C16.0002 11.7015 16.2986 12 16.6668 12C16.8785 12 17.0672 11.9013 17.1893 11.7475L18.0002 14.6667H14.6668V17.3333H13.3335V14.6667H10.0002L10.811 11.7475C10.9332 11.9013 11.1218 12 11.3335 12C11.7017 12 12.0002 11.7015 12.0002 11.3333C12.0002 10.9651 11.7017 10.6667 11.3335 10.6667C11.2512 10.6667 11.1723 10.6816 11.0996 10.7089L11.5343 9.1436C11.6545 9.26099 11.8189 9.33333 12.0002 9.33333C12.3684 9.33333 12.6668 9.03486 12.6668 8.66667C12.6668 8.29848 12.3684 8 12.0002 8C11.9475 8 11.8963 8.00611 11.8471 8.01765L12.2607 6.52872C12.3732 6.61523 12.514 6.66667 12.6668 6.66667C13.035 6.66667 13.3335 6.36819 13.3335 6C13.3335 5.63181 13.035 5.33333 12.6668 5.33333C12.6414 5.33333 12.6163 5.33476 12.5916 5.33753Z",
          fill: "#259D4B"
        }
      )
    ]
  }
);
const VpFlagNfAsset = forwardRef(FlagNfAsset);

export { VpFlagNfAsset as default };
